import { render, staticRenderFns } from "./DraggablePopup.vue?vue&type=template&id=ea19ed2a&scoped=true"
import script from "./DraggablePopup.vue?vue&type=script&lang=js"
export * from "./DraggablePopup.vue?vue&type=script&lang=js"
import style0 from "./DraggablePopup.vue?vue&type=style&index=0&id=ea19ed2a&prod&lang=less"
import style1 from "./DraggablePopup.vue?vue&type=style&index=1&id=ea19ed2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@6.26.3_cache-loader@4.1.0_webpac_ddacfd63a0804571a953918ce6bcb0d4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea19ed2a",
  null
  
)

export default component.exports